<template>
  <div class="userlist">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <template slot="userName">
          <el-input v-model="formData.userName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="companyEmail">
          <el-input v-model="formData.companyEmail" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <!-- <template slot="telephone">
          <el-input v-model="formData.telephone" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="mobilePhone">
          <el-input v-model="formData.mobilePhone" :placeholder="$t('queryForm.pleaseEnter')" />
        </template> -->

        <template slot="companyName">
          <el-input v-model="formData.companyName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="roleId">
        <el-select v-model="formData.roleId" :placeholder="$t('queryForm.pleaseSelect')">
          <el-option
            v-for="item in roleList"
            :key="item.key"
            :label="item.text"
            :value="item.key"
          />
        </el-select>
      </template>

        <template slot="status">
          <el-select v-model="formData.status" :placeholder="$t('queryForm.pleaseSelect')">
            <!-- <el-option :label="$t('administration.whole')" value /> -->
            <el-option :label="$t('button.enable')" value="1" />
            <el-option :label="$t('button.disable')" value="0" />
          </el-select>
        </template>
      </form-table-page>
    </card>

    <card style="margin-top:10px;">
      <div class="table-content-box">
        <div class="btn-list-box form-btn-list">
          <cus-btn type="add" @click="userAdd()" v-if="buttonPerCheck('add')" />
          <cus-btn type="reset" @click="resetBtn()" v-if="buttonPerCheck('reset')" />
          <cus-btn type="enable" @click="importBtn()" v-if="buttonPerCheck('enable')" />
          <cus-btn type="disable" @click="desableBtn()" v-if="buttonPerCheck('disable')" />
          <cus-btn type="delete" @click="delBtn()" v-if="buttonPerCheck('delete')" />
        </div>

        <table-page
          ref="table"
          :table-data="tableData"
          :search-method="handleSearch"
          :current-page="pageNum"
          :total="total"
          :change-fun="changeTablePage"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">
            <el-table-column
              prop="tab1"
              :label="$t('formData.userName')"
              align="center"
              show-overflow-tooltip
              min-width="150"
            />

            <el-table-column
              prop="tab2"
              :label="$t('queryForm.companyEmail')"
              align="center"
              show-overflow-tooltip
              min-width="200"
            />

            <el-table-column
              prop="tab3"
              :label="$t('queryForm.companyName')"
              align="center"
              show-overflow-tooltip
              min-width="150"
            />

            <el-table-column
              prop="tab4"
              :label="$t('queryForm.status')"
              align="center"
              width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div>{{ scope.row.tab4 == '0' ? $t("button.disable") : $t("button.enable") }}</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="tab5"
              :label="$t('administration.userPhoto')"
              align="center"
              width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <headimg :size="40" :src="scope.row.tab5" />
              </template>
            </el-table-column>

            <el-table-column
              prop="tab6"
              :label="$t('formData.roleName')"
              align="center"
              show-overflow-tooltip
              min-width="150"
            />

            <el-table-column
              class-name="tabAction table-column-action-dropdown"
              prop="tab7"
              :label="$t('formData.action')"
              align="center"
              show-overflow-tooltip
              width="220"
            >
              <template slot-scope="item">
                <el-dropdown @command="constantCustom.commonDropdownCommandHandler">
                  <span class="el-dropdown-link">
                    <!-- {{$t('formData.action')}}<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <i class="el-icon-ali-TechnicalArea"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="buttonPerCheck('view')" :command="{thisCom:thisCom,action:seeBtn,param:[item.row.ids]}">{{ $t('button.view') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('edit')" :command="{thisCom:thisCom,action:'updataBtn',param:[item.row.ids]}">{{ $t('button.edit') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('delete')" :command="{action:deleteBtn,param:[item.row.ids]}">{{ $t("button.delete") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('authorize')" :command="{action:empower,param:[item.row.ids,item.row.type,item.row.tab1,item.row.tab2,item.row.tab6]}">{{ $t('administration.assign') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-link
                  type="primary"
                  :underline="false"
                  @click="seeBtn(item.row.ids)"
                  v-if="buttonPerCheck('view')"
                >{{ $t("button.view") }}</el-link>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="updataBtn(item.row.ids)"
                  v-if="buttonPerCheck('edit')"
                >{{ $t("button.edit") }}</el-link>
                <row-inline-confirm
                  @button-click-event="deleteBtn(item.row.ids)"
                  v-if="buttonPerCheck('delete')"
                >
                  <el-link slot="button" type="primary" :underline="false">{{ $t("button.delete") }}</el-link>
                </row-inline-confirm>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="empower(item.row.ids,item.row.type,item.row.tab1,item.row.tab2,item.row.tab6,item.row.roleType)"
                  v-if="buttonPerCheck('authorize')"
                >{{ $t("administration.assign") }}</el-link> -->
              </template>
            </el-table-column>
          </template>
        </table-page>
      </div>
    </card>
  </div>
</template>

<script>
import {
  userList,
  userDelete,
  userResetPassword,
  userEnable,
  userDisable,
  userisCanAuthorize,
  roleSelect
} from "../../api/adminManagement";
export default {
  data() {
    return {
      thisCom: this,
      multipleSelection: [],
      tableData: [],

      pageSize: 10,
      pageNum: 1,
      total: 0,

      formData: {
        userName: "",
        companyEmail: "",
        // telephone: "",
        // mobilePhone: "",
        companyName: "",
        roleId: "",
        status: ""
      },
      formLabel: {
        userName: "formData.userName",
        companyEmail: "queryForm.companyEmail",
        // telephone: "formData.telephone",
        // mobilePhone: "formData.mobilePhone",
        companyName: "queryForm.companyName",
        roleId: "queryForm.roleName",
        status: "queryForm.status"
      },
      roleList: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.loadRoleList()
      this.Query()
    }
  },
  mounted() {
    this.loadRoleList();//加载角色列表
    this.Query();
  },
  methods: {
    /**
     * 加载角色列表
     */
    loadRoleList(){
      let queryDataRole = {}
      let roleList = []
      roleSelect(queryDataRole)
        .then(response => {
          if (response.code === 200) {
            if (response.data && response.data.list) {
              for (let i = 0; i < response.data.list.length; i++) {
                let role = {}
                role = {
                  key: response.data.list[i].id,
                  text: response.data.list[i].name
                  // description: response.data.list[i].description,
                  // status: response.data.list[i].status 
                }
                roleList.push(role)
              }
            }           
          }
        })
        .finally(() => {        
          this.roleList = roleList
        })
    },

    /**
     * 查询方法
     * @constructor
     */
    Query(type) {
      this.pageNum = 1;
      this.listMain(1, this.$refs.table.pageSize);
    },

    changeTablePage(currentPage, pageSize) {
      this.pageNum = currentPage;
      this.$refs.table.pageSize = pageSize;
      this.listMain(currentPage, pageSize, this.$refs.table.queryData);
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      this.pageNum = 1;
      // console.log("重置");
    },

    /**
     * 监听分页
     */
    handleSearch(currentPage) {
      // console.log("22222", currentPage);
      this.fetchRemoteData(
        currentPage,
        this.$refs.table.pageSize,
        this.$refs.table.queryData
      );
    },

    userAdd() {
      this.$router.push({
        name: "userListAdd"
      });
    },

    /**
     * table 选中事件
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log("11111111", this.multipleSelection);
    },

    listMain(currentPage, pageSize, queryData) {
      const self = this;
      if (!queryData) {
        queryData = {
          pageNum: currentPage,
          pageSize: pageSize,
          name: self.formData.userName,
          email: self.formData.companyEmail,
          telephone: self.formData.telephone,
          mobile: self.formData.mobilePhone,
          status: self.formData.status,
          companyName: self.formData.companyName,
          roleId: self.formData.roleId
        };
      } else {
        queryData.pageNum = currentPage;
        queryData.pageSize = pageSize;
      }
      userList(queryData).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.list) {
            self.tableData = [];
            for (let i = 0; i < response.data.list.length; i++) {
              let obj = {};
              let arrName = "";
              if (
                response.data.list[i].roles.length > 0 &&
                response.data.list[i].roles[0]
              ) {
                for (let a = 0; a < response.data.list[i].roles.length; a++) {
                  if (a == 0) {
                    arrName += response.data.list[i].roles[a].name;
                  } else {
                    arrName += "," + response.data.list[i].roles[a].name;
                  }
                }
              } else {
                arrName = "";
              }
              obj = {
                ids: response.data.list[i].id,
                type: response.data.list[i].type,
                tab1: response.data.list[i].name,
                tab2: response.data.list[i].email,
                tab3: response.data.list[i].companyName,
                tab4: response.data.list[i].status,
                tab5: response.data.list[i].photo
                  ? response.data.list[i].photo
                  : require("../../assets/phone.jpg"),
                tab6: arrName,
                roleType: response.data.list[i].roles[0].roleType
              };
              self.tableData.push(obj);
            }
            this.total = response.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          // 保存当前查询条件
          this.$refs.table.queryData = queryData;
        }
      });
    },

    // 查看
    seeBtn(ids) {
      // console.log(ids);
      this.$router.push({ name: "userListAdd", params: { id: ids, type: 1 } });
    },

    //  修改
    updataBtn(ids) {
      this.$router.push({ name: "userListAdd", params: { id: ids, type: 2 } });
    },

    //  项目授权
    empower(ids, type, tab1, tab2, tab6,roleType) {
      const param = {
        userId: ids
      };
      userisCanAuthorize(param).then(response => {
        if (response.code === 200) {
          if (response.data) {
            this.$router.push({
              name: "systemPermissions",
              params: {
                id: ids,
                type: type,
                uname: tab1,
                uemail: tab2,
                uarrname: tab6,
                roleType:roleType
              }
            });
          } else {
            this.$message({
              message: response.message,//this.$t("administration.Noauthority"),
              type: "error"
            });
          }
        }
      });
    },

    // 删除
    deleteBtn(id) {
      this.$confirm(
          this.$t("administration.deleteAccount"),
          this.$t("messageCommon.tips"),
          {
            confirmButtonText: this.$t("checkList.confirm"),
            cancelButtonText: this.$t("checkList.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            const self = this;

            const param = {
              ids: [id]
            };
            userDelete(param).then(response => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: response.message
                });
                this.Query();
              }
            });
          })
          .catch(() => {})
    },

    // 密码批量重置
    resetBtn() {
      // console.log(this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("administration.selectAccount"),
          type: "warning"
        });
        return;
      } else {
        const self = this;
        this.$confirm(
          this.$t("administration.resetPassword"),
          this.$t("messageCommon.tips"),
          {
            confirmButtonText: this.$t("checkList.confirm"),
            cancelButtonText: this.$t("checkList.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            const idd = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
              idd[i] = this.multipleSelection[i].ids;
            }
            const param = {
              ids: idd
            };
            userResetPassword(param).then(response => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: response.message
                });
                this.Query();
              }
            });
          })
          .catch(() => {});
      }
    },

    // 批量删除
    delBtn() {
      // console.log(this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("administration.selectAccount"),
          type: "warning"
        });
        return;
      } else {
        const self = this;
        this.$confirm(
          this.$t("administration.deleteAccount"),
          this.$t("messageCommon.tips"),
          {
            confirmButtonText: this.$t("checkList.confirm"),
            cancelButtonText: this.$t("checkList.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            const idd = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
              idd[i] = this.multipleSelection[i].ids;
            }
            const param = {
              ids: idd
            };
            userDelete(param).then(response => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: response.message
                });
                this.Query();
              }
            });
          })
          .catch(() => {});
      }
    },

    // 批量启用
    importBtn() {
      // console.log(this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("administration.selectAccount"),
          type: "warning"
        });
        return;
      } else {
        const self = this;
        this.$confirm(
          this.$t("administration.batchEnabled"),
          this.$t("messageCommon.tips"),
          {
            confirmButtonText: this.$t("checkList.confirm"),
            cancelButtonText: this.$t("checkList.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            const idd = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
              idd[i] = this.multipleSelection[i].ids;
            }
            const param = {
              ids: idd
            };
            userEnable(param).then(response => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: response.message
                });
                this.Query();
              }
            });
          })
          .catch(() => {});
      }
    },

    // 批量禁用
    desableBtn() {
      // console.log(this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("administration.selectAccount"),
          type: "warning"
        });
        return;
      } else {
        const self = this;
        this.$confirm(
          this.$t("administration.batchDisable"),
          this.$t("messageCommon.tips"),
          {
            confirmButtonText: this.$t("checkList.confirm"),
            cancelButtonText: this.$t("checkList.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            const idd = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
              idd[i] = this.multipleSelection[i].ids;
            }
            const param = {
              ids: idd
            };
            userDisable(param).then(response => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: response.message
                });
                this.Query();
              }
            });
          })
          .catch(() => {});
      }
    }

    // iscan(){
    //   const param = {
    //     ids: idd
    //   }
    //   userisCanAuthorize(param)
    //   .then(response => {
    //     if (response.code === 200) {
    //       this.$message({
    //         type: 'success',
    //         message: response.message
    //       })
    //       this.Query()
    //     }
    //   })
    // }
  }
};
</script>

<style scoped lang="scss">
</style>
